import { render, staticRenderFns } from "./invoiceInfoCell.vue?vue&type=template&id=b6b3c416"
import script from "./invoiceInfoCell.vue?vue&type=script&lang=js"
export * from "./invoiceInfoCell.vue?vue&type=script&lang=js"
import style0 from "./invoiceInfoCell.vue?vue&type=style&index=0&id=b6b3c416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports